import * as React from 'react';
import styled from 'styled-components';

import {
 InspectorTimeTrackingReports,
  ReportTableType,
} from '../../api/reports';

import { DATETIME_FORMAT } from '../../constants';

import Table from '../../organisms/Table';

import { formatDateTime } from '../../utils/formatDate';
import tableColumnsFormatter from '../../utils/tableColumnsFormatter';
import Wrapper from './print-mixin';

const InspectorTimeTrackingReport = React.forwardRef(
  (
    {
      fromDate,
      toDate,
      inspector,
      setIsValidForExport,
    }: ReportTableType,
    ref,
  ) => {
    const [
      isNullInspections,
      setIsNullInspections,
    ] = React.useState(false);
    const [lastComment, setLastComment] = React.useState(
      null,
    );

    const data = {
      fromDate,
      toDate,
      inspectors: inspector.map(i => i.id),
    };
const [totalPermits, setTotalPermits] = React.useState([]);
    const getModifiedDailyInspectionReport = () =>
      Promise.all([InspectorTimeTrackingReports(data)])
        .then(([reports]) => {
          if (reports.data?.length === 0) {
            setIsNullInspections(true);
            setIsValidForExport(false);
          } else {
            setIsNullInspections(false);
            setIsValidForExport(true);

            const commentData = reports.data.map(el => {
              return {
                id: el.id,
                lastComment: el.lastComment,
              };
            });

            setLastComment({
              commentData,
              isDailyInspection: true,
            });

              setTotalPermits(prevState => [...prevState, {
                title: "Total Permits",
                value: reports.data?.length,
              }]);
          }

          return {
            ...reports,
            data: {
              ...reports.data,
              results: reports.data.map(el => {
                return {
                  projectNamePermitName: `${el.projectName} | ${el.permitName}`,
                  permitNumber: el.permitNumber,
                  projectAddress: el.projectAddress,
                  inspector: el.inspectorName,
                  inspectionNumber: el.id,
                  inspectionType: el.inspectionTypeName,
                  status: el.status,
                  inspectionDate: el.inspectionDate,
                };
              }),
            },
          };
        })
        .catch(err => console.log(err))
        .finally(() => {});

    const columns = column => {
      switch (column) {
        case 'contactDetails':
          return 'Contact Details';
        case 'contactName':
          return 'Contact';
        case 'inspectionNumber':
          return 'Inspection Number';
        case 'inspectionDate':
          return 'Inspection Date';
        case 'inspectionTypeName':
          return 'Inspection Type';
        case 'jurisdiction':
          return 'Jurisdiction';
        case 'permitNumber':
          return 'Permit Number';
        case 'projectAddress':
          return 'Project Address';
        case 'projectManager':
          return 'Project Manager';
        case 'period':
          return 'AM/PM';
        case 'projectNamePermitName':
          return 'Project Name | Permit Name';
        case 'inspector':
          return 'Inspector';
        default:
          return tableColumnsFormatter(column);
      }
    };

    const columnsOrder = [
      'projectNamePermitName',
      'permitNumber',
      'projectAddress',
      'inspector',
      'inspectionNumber',
      'inspectionType',
      'status',
      'inspectionDate',
    ];

    if (isNullInspections) {
      return (
        <InfoText>
          No project was found with selected date or
          Inspector.
        </InfoText>
      );
    }

    return (
      <Wrapper ref={ref}>
        <Title>Inspector Time Tracking Report</Title>

        <List>
          <li>
            <Bold>Inspector Name(s): </Bold>
            {inspector && inspector.length
                    ? inspector.map(i => `${i.firstName} ${i.lastName}`).join(", ")
                    : "None selected"}
          </li>
          <li>
            <Bold>Date: </Bold>From: {fromDate} To: {toDate}
          </li>
          <li>
            <Bold>Report Date: </Bold>
            {formatDateTime(new Date(), DATETIME_FORMAT)}
          </li>
        </List>

        <Table
          customSearch
          columnsOrder={columnsOrder}
          columns={columns}
          rows={getModifiedDailyInspectionReport}
          onEdit={null}
          onDelete={null}
          onConfigure={null}
          additionalActions={null}
          additionalRow={lastComment}
          additionalBottomRow={totalPermits}
        />
      </Wrapper>
    );
  },
);

const FONT_STACK = `'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
  font-family: ${FONT_STACK};
  li {
    padding: 6px 0;
    font-size: 0.9375rem;
    color: var(--mainText);
  }
`;

const Bold = styled.span`
  color: var(--mainText);
  font-weight: 700;
`;
const Title = styled.h1`
  margin: 0 0 16px;
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--mainText);
  font-family: ${FONT_STACK};
`;

const InfoText = styled.div`
  margin: 0 auto;
  padding: 24px;
  font-size: 1rem;
  color: var(--neutral-500);
  text-align: center;
  background: var(--neutral-0);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-xs);
  font-family: ${FONT_STACK};
`;

export default InspectorTimeTrackingReport;
